import React, { useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __ConsolidationLeters, __MessageTypes, __Deactivate, __AppElementType } from '../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetBoarScope } from '../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../components/Common/Message/MessageBox';
import PropTypes from 'prop-types';
import CTextBox from '../../../components/Common/CTextBox';

import { isNullUndefinedOrEmpty, showMessage, treeify } from '../../../common/Helpers';
import { Checkbox, Dropdown } from '@fluentui/react';
import { __Consolidation } from '../../../common/Dictionaries';
import { __ComponentTypes } from '../../../common/Dictionaries';
import { useDispatch, useSelector } from 'react-redux';
import CLabel from '../../../components/Common/CLabel';
import DialogPropertyListValues from './DialogPropertyListValues';
import { addContractProp, deleteContractProp, updateContractProp } from '../../../services/sBook/contract.service';
import { action_setContractPropValueSelected, action_setContractProps } from '../../../reducers/actions/KPI/actions';
import CValidator from '../../../components/Common/CValidator';

const SidePanelConfigureProps = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const propertyNameRegex = /^[a-zA-Z_$][a-zA-Z0-9_]*$/;

    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
    const { _contractPropValueIdSelected: contractPropValueIdSelected } = useSelector((state) => state.maintainerScope);
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_ListContracts = null,
        inputParam_SetterListContracts = null,
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [isDialogPropertyValuesVisible, { setTrue: showDialogPropertyValues, setFalse: hideDialogPropertyValues }] = useBoolean(false);
    const [baseContractListProp, setBaseContractListProp] = useState(JSON.parse(JSON.stringify(listContractsProps)))

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setBaseContractListProp(listContractsProps)
        showMessage(setMessageConfig, false, null, null)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onDeactivateChanged = (ev, checked, itemId) => {
        const aux_contractsPropsList = [...baseContractListProp]
        const item = aux_contractsPropsList.find(x => x.id === itemId)
        item.deactivate = checked;
        setBaseContractListProp(aux_contractsPropsList);
    };

    const onRequiredChanged = (ev, checked, itemId) => {
        const aux_contractsPropsList = [...baseContractListProp]
        const item = aux_contractsPropsList.find(x => x.id === itemId)
        item.required = checked;
        setBaseContractListProp(aux_contractsPropsList);
    };

    const onChangeValueType = (currentNode, selectedNodes, itemId) => {
        const aux_contractsPropsList = [...baseContractListProp]
        const item = aux_contractsPropsList.find(x => x.id === itemId)
        item.valType = selectedNodes.key;
        setBaseContractListProp(aux_contractsPropsList);
    };

    const changeContractPropertyName = (arr, oldName, newName) => {
        return arr.map(obj => {
            const objectCopy = { ...obj };
            const propertyValue = objectCopy[oldName];
            delete objectCopy[oldName];
            return { [newName]: propertyValue, ...objectCopy };
        });
    };

    const validateContractProp = (item) => {
        let flag = true;

        flag = flag === true ? !isNullUndefinedOrEmpty(item.cpropCode) : flag;
        flag = flag === true ? !isNullUndefinedOrEmpty(item.name) : flag;
        flag = flag === true ? !isNullUndefinedOrEmpty(item.shortName) : flag;
        flag = flag === true ? !isNullUndefinedOrEmpty(item.valType) : flag;

        flag = !propertyNameRegex.test(item.shortName) ? false : flag;
        
        return flag;
    }

    const validatePropertyObjectName = (propertyName) => {
        let textError = '';
        
        if (isNullUndefinedOrEmpty(propertyName)) {
            textError = 'data-lang-lbl-required';
        }
        else if (!propertyNameRegex.test(propertyName)) {
            textError = 'data-lang-lbl-invalidtext';
        }
        else {
            textError = '';
        }

        return textError
    }

    const onSaveProp = (itemId) => {
        const aux_contractsPropsList = [...baseContractListProp];
        let item = aux_contractsPropsList.find(x => x.id === itemId);

        if (validateContractProp(item)) {
            if (itemId > 0) {
                updateContractProp(item).then((serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        const itemId = serviceResponse.data.data;

                        setBaseContractListProp(aux_contractsPropsList)
                        dispatch(action_setContractProps(aux_contractsPropsList))

                        const newItem = aux_contractsPropsList.find(x => itemId);
                        const baseItem = baseContractListProp.find(x => itemId);
                        const auxListContracts = changeContractPropertyName(inputParam_ListContracts, baseItem.name, newItem.name)

                        inputParam_SetterListContracts && inputParam_SetterListContracts(auxListContracts)

                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                addContractProp(item).then((serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        const responseItemId = serviceResponse.data.data;

                        aux_contractsPropsList.forEach(element => {
                            if (element.id === itemId) {
                                element.id = responseItemId;
                            }
                        });

                        setBaseContractListProp(aux_contractsPropsList)
                        dispatch(action_setContractProps(aux_contractsPropsList))

                        const auxListContracts = inputParam_ListContracts.map(contract => {
                            const contractCopy = { ...contract }; 
                            contractCopy[item.name] = null;
                            return contractCopy;
                        });

                        inputParam_SetterListContracts && inputParam_SetterListContracts(auxListContracts)

                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onDeleteProp = (item) => {
        if (item.id > 0) {
            deleteContractProp(item.id).then((serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    let aux_contractsPropsList = [...baseContractListProp];
                    aux_contractsPropsList = aux_contractsPropsList.filter(x => x.id !== item.id);

                    setBaseContractListProp(aux_contractsPropsList)
                    dispatch(action_setContractProps(aux_contractsPropsList));

                    const auxListContracts = inputParam_ListContracts.map(contract => {
                        const contractCopy = { ...contract };
                        delete contractCopy[item.name];
                        return contractCopy;
                    });

                    inputParam_SetterListContracts && inputParam_SetterListContracts(auxListContracts)

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            let aux_contractsPropsList = [...baseContractListProp];
            aux_contractsPropsList = aux_contractsPropsList.filter(x => x.id !== item.id);

            setBaseContractListProp(aux_contractsPropsList)
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed')); 
        }
    };

    const onOpenPropertyValuesDialog = (contractPropId) => {
        dispatch(action_setContractPropValueSelected(contractPropId))
        showDialogPropertyValues()
    }

    const setterProperty = (controlValue, textBoxName) => {
        const aux_contractsPropsList = [...baseContractListProp]

        const fieldName = textBoxName.split('__x__')[0];
        const itemId = parseInt(textBoxName.split('__x__')[1]);

        const item = aux_contractsPropsList.find(x => x.id === itemId)
        item[fieldName] = controlValue;

        if (fieldName === 'shortName') {
            //validatePropertyObjectName(item[fieldName])
        }

        setBaseContractListProp(aux_contractsPropsList)
    }

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onAddNewProp = () => {
        const aux_contractsPropsList = [...baseContractListProp]
        const minId = aux_contractsPropsList.reduce((min, item) => (item.id < min ? item.id : min), 0);

        aux_contractsPropsList.push({
           id: (minId -1),
           cpropNemo: '',
           cpropCode: '',
           valType: '',
           required: false,
           name: '',
           shortName: '',
           deactivate: false,
        })

        setBaseContractListProp(aux_contractsPropsList)
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ onAddNewProp } styles={_global_buttonStyles}>{ t('data-lang-btn-add') }</PrimaryButton>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-configureprops') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    baseContractListProp && baseContractListProp.map((prop, index) => (
                        <Card key={index} className="my-2">
                            <Card.Header
                                className="card-header-compact"
                                style={{backgroundColor: "#c5c5c5", maxHeight: "30px"}}>
                                    <b>{`${t('data-lang-lbl-prop')}: ${prop.name}`}</b>
                                    <div className='book-toolbar'>
                                    </div>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col xl={6} className='py-1'>
                                        <CTextBox
                                            labelText={t('data-lang-lbl-code')}
                                            textBoxName={`cpropCode__x__${prop.id}`}
                                            controlValue={prop.cpropCode}
                                            setterControlValue={setterProperty}
                                            isInValid={isNullUndefinedOrEmpty(prop.cpropCode)}
                                        />
                                    </Col>
                                    <Col xl={6} className='py-1'>
                                        <CTextBox
                                            labelText={t('data-lang-lbl-name')}
                                            textBoxName={`name__x__${prop.id}`}
                                            controlValue={prop.name}
                                            setterControlValue={setterProperty}
                                            isInValid={isNullUndefinedOrEmpty(prop.name)}
                                        />
                                    </Col>
                                    <Col xl={6} className='py-1'>
                                        <CTextBox
                                            labelText={t('data-lang-lbl-shortname')}
                                            textBoxName={`shortName__x__${prop.id}`}
                                            controlValue={prop.shortName}
                                            setterControlValue={setterProperty}
                                        />
                                        <CValidator
                                            isInValid={isNullUndefinedOrEmpty(prop.shortName) ? false : (validatePropertyObjectName(prop.shortName) !== "")}
                                            inValidText={t(validatePropertyObjectName(prop.shortName))}
                                        />
                                    </Col>
                                    <Col xl={6} className='py-1'>
                                        <CLabel labelText={t('data-lang-lbl-valtype')} />
                                        <Dropdown
                                            placeholder={t('data-lang-lbl-select')}
                                            styles={
                                                {
                                                    title: { height: "30px" },
                                                    errorMessage: { paddingTop: "1px", fontSize: "14px"},
                                                    root: { paddingTop: "1px" }
                                                }
                                            }
                                            options={[
                                                {key: 'list', text: t('data-lang-lbl-list'), title: t('data-lang-lbl-list')},
                                                {key: 'num', text: t('data-lang-lbl-number'), title: t('data-lang-lbl-number')},
                                                {key: 'str', text: t('data-lang-lbl-text'), title: t('data-lang-lbl-text')}
                                            ]}
                                            selectedKey={prop.valType}
                                            required={true}
                                            errorMessage={isNullUndefinedOrEmpty(prop.valType) ? t('data-lang-msg-required') : undefined}
                                            disabled={prop.id > 0}
                                            onChange={(event, option) => onChangeValueType(event, option, prop.id)}
                                        />
                                    </Col>
                                    <Col xl={6} className='py-1 d-flex'>
                                        <CLabel labelText={t('data-lang-lbl-required')} />
                                        <Checkbox checked={prop.required} onChange={(ev, checked) => onRequiredChanged(ev, checked, prop.id)} />
                                    </Col>
                                    <Col xl={6} className='py-1 d-flex'>
                                        <CLabel labelText={t('data-lang-lbl-deactivated')} />
                                        <Checkbox checked={prop.deactivate} onChange={(ev, checked) => onDeactivateChanged(ev, checked, prop.id)} />
                                    </Col>
                                </Row>
                                <Row className='pt-1 px-0 mx-0 text-end'>
                                    <Col className='px-0 mx-0'>
                                        {
                                            prop.valType === 'list' && prop.id > 0 &&
                                            <PrimaryButton onClick={ () => onOpenPropertyValuesDialog(prop.id) } styles={_global_buttonStyles}>{ t('data-lang-btn-configure') }</PrimaryButton>
                                        }
                                        <PrimaryButton onClick={ () => onSaveProp(prop.id) } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                                        <PrimaryButton className='me-0' onClick={ () => onDeleteProp(prop) } styles={_global_buttonStyles}>{ t('data-lang-btn-delete') }</PrimaryButton>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    ))
                }
                <>
                    <DialogPropertyListValues
                        inputParam_IsDialogOpen={isDialogPropertyValuesVisible}
                        inputParam_SetterIsDialogOpen={hideDialogPropertyValues}
                        inputParam_ContractPropId={contractPropValueIdSelected}
                    />
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelConfigureProps.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelConfigureProps;